import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';

import { environment } from '#environments';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  private http = inject(HttpClient);

  public getCurrentUserAdminGroups(buId: number) {
    return this.http.get<Dtos.Group>(`${environment.apiUrl}/group/currentUserGrps/${buId}`);
  }

  public getGroupsByBu(buId: number): Observable<Dtos.Group[]> {
    return this.http.get<Dtos.Group[]>(`${environment.apiUrl}/group/currentUserAdminGrps/${buId}`);
  }

  public addNewGroup(group: Dtos.Group): Observable<Dtos.Group> {
    return this.http.post<Dtos.Group>(`${environment.apiUrl}/group`, group);
  }

  public getGroupById(groupId: number): Observable<Dtos.Group> {
    return this.http.get<Dtos.Group>(`${environment.apiUrl}/group/${groupId}`);
  }

  public updateGroup(group: Dtos.Group): Observable<Dtos.Group> {
    return this.http.put<Dtos.Group>(`${environment.apiUrl}/group`, group);
  }

  public addGroupUser(gUser: Dtos.GroupUser) {
    return this.http.post<Dtos.GroupUser>(`${environment.apiUrl}/group/addGroupUser`, gUser);
  }

  public removeGroupUser(id: number): Observable<Dtos.GroupUser> {
    return this.http.put<Dtos.GroupUser>(`${environment.apiUrl}/group/removeGroupUser/${id}`, null);
  }
}
